/**
 * Shared response unwrapper for cargo-server's standard envelope.
 *
 * cargo-server uniformly returns one of two shapes:
 *   { success: true, data: T }   — the canonical envelope
 *   T                            — bare on a few legacy / public endpoints
 *
 * unwrap() peels off `data` when present, otherwise returns the body
 * verbatim. axios's outer `{ data: <body> }` is also unwrapped here so
 * callers don't have to care about which layer is the "data" shell.
 *
 * Single source of truth — extracted out of the per-domain api files
 * (`companies.ts`, `containers.ts`, `fuelRefills.ts`, `tripPlan.ts`)
 * which all had identical copies.
 */
export function unwrap<T>(res: { data?: any }): T {
  return (res.data?.data ?? res.data) as T;
}
